(() => {
  const VERSION='2026-08-14.1';
  if(window.PBDesktopAuditCoreV1?.version===VERSION)return;

  const V=window.PBVariantV2;
  const C=window.PBUSBProductCatalogV2||{};
  if(!V){window.PBDesktopAuditCoreV1={version:VERSION,active:false};return;}

  const ROOT_SELECTOR='[id^="PBUSBBoxCustomizer-"]';
  const MODAL_SELECTOR='.pb-photo-customizer__modal,.pb-usb-customizer__modal,[data-pb-customizer-modal]';
  const roots=[];
  const q=(r,s)=>r?.querySelector(s)||null;
  const qa=(r,s)=>r?[...r.querySelectorAll(s)]:[];
  const a=(r,s)=>q(r,`${s}.is-active`);
  const d=(r,s,k,f='')=>a(r,s)?.dataset?.[k]||f;
  const parse=(r,s,f)=>{try{return JSON.parse(q(r,s)?.textContent||JSON.stringify(f))}catch{return f}};
  let cfg={};
  try{cfg=JSON.parse(document.querySelector('[data-pb-logo-v3-config]')?.textContent||'{}')}catch{}

  const money=c=>new Intl.NumberFormat(undefined,{
    style:'currency',
    currency:window.Shopify?.currency?.active||cfg.currency||'USD'
  }).format(Number(c||0)/100);

  const cents=v=>{
    const raw=v?.price??0;
    const n=Number(raw||0);
    if(!Number.isFinite(n))return 0;
    return String(raw).includes('.')?Math.round(n*100):Math.round(n);
  };

  const ctxFor=t=>t instanceof Element
    ? roots.find(x=>x.scope.contains(t)||x.root.contains(t))||null
    : null;

  // V2's visible capacity is authoritative. The hidden legacy capacity control is
  // retained only as a migration carrier for old inline code.
  const capacity=x=>
    d(x.scope,'[data-pb-usb-capacity-v2]','pbUsbCapacityV2',
      d(x.scope,'[data-usb-capacity]','usbCapacity','8GB'));

  const boxState=x=>
    a(x.scope,'[data-pb-logo="box"]')?'logo':
    d(x.scope,'[data-personalization]','personalization','standard')==='personalized'?'text':'blank';

  const usbState=x=>
    a(x.scope,'[data-pb-logo="usb"]')?'logo':
    d(x.scope,'[data-usb-engraving]','usbEngraving','no')==='yes'?'text':'none';

  const usbSelection=(x,state=usbState(x))=>{
    const key=d(x.scope,'[data-usb-key]','usbKey');
    const product=C[key]||null;
    const cap=capacity(x);
    const variant=V.resolveVariant(product?.variants||[],{
      domain:'usb',
      state,
      requiredValues:[cap]
    });
    return{key,product,capacity:cap,variant};
  };

  const setLegacyLabel=(button,text)=>{
    if(!button)return;
    let el=q(button,'.pb-usb-addon__price-label');
    if(!el){
      el=document.createElement('strong');
      el.className='pb-usb-addon__price-label';
      button.appendChild(el);
    }
    el.textContent=text||'';
    el.hidden=!text;
  };

  const cleanChoicePrice=(button,text)=>{
    if(!button)return;
    const v22=q(button,'[data-pb-v22-price]');
    if(v22){
      qa(button,':scope > .pb-usb-addon__price-label').forEach(el=>el.remove());
      v22.textContent=text||'';
      return;
    }
    setLegacyLabel(button,text);
  };

  const syncLabels=x=>{
    if(!Object.keys(C).length)return;

    let globalLow=null;
    qa(x.scope,'[data-usb-key]').forEach(button=>{
      const product=C[button.dataset.usbKey];
      if(!product?.variants?.length||button.hidden)return;
      const prices=product.variants
        .filter(v=>V.stateForVariant(v,'usb')==='none'&&v.available!==false)
        .map(cents)
        .filter(Boolean);
      if(!prices.length){
        setLegacyLabel(button,'Unavailable');
        return;
      }
      const low=Math.min(...prices);
      globalLow=globalLow===null?low:Math.min(globalLow,low);
      setLegacyLabel(button,`from +${money(low)}`);
    });

    if(globalLow!==null){
      setLegacyLabel(q(x.scope,'[data-usb-choice="add"]'),`from +${money(globalLow)}`);
    }

    const selected=usbSelection(x,'none');
    const base=selected.variant;
    qa(x.scope,'[data-pb-usb-capacity-v2]').forEach(button=>{
      const v=V.resolveVariant(selected.product?.variants||[],{
        domain:'usb',
        state:'none',
        requiredValues:[button.dataset.pbUsbCapacityV2]
      });
      const el=q(button,'.pb-usb-addon__price-label');
      if(el)el.textContent=!v?'Not configured':v.available===false?'Unavailable':money(cents(v));
    });

    const textButton=q(x.scope,'[data-usb-engraving="yes"]');
    const textVariant=V.resolveVariant(selected.product?.variants||[],{
      domain:'usb',
      state:'text',
      requiredValues:[selected.capacity]
    });
    cleanChoicePrice(
      textButton,
      !textVariant?'Not configured':
      textVariant.available===false?'Unavailable':
      base?`+${money(Math.max(cents(textVariant)-cents(base),0))}`:'Not configured'
    );

    const logoButton=q(x.scope,'[data-pb-logo="usb"]');
    const logoVariant=V.resolveVariant(selected.product?.variants||[],{
      domain:'usb',
      state:'logo',
      requiredValues:[selected.capacity]
    });
    cleanChoicePrice(
      logoButton,
      !logoVariant?'Not configured':
      logoVariant.available===false?'Unavailable':
      base?`+${money(Math.max(cents(logoVariant)-cents(base),0))}`:'Not configured'
    );
  };

  const syncPriceAndButton=x=>{
    const boxVariants=parse(x.root,'[data-pb-variants-json]',[]);
    const color=d(x.scope,'[data-color]','color','Cream');
    const bs=boxState(x);
    const box=V.resolveVariant(boxVariants,{
      domain:'box',
      state:bs,
      requiredValues:[color]
    });
    const add=q(x.scope,'[data-pb-add]');
    const usbAdded=d(x.scope,'[data-usb-choice]','usbChoice','none')==='add';
    const logoFlow=bs==='logo'||usbState(x)==='logo';

    if(!box){
      qa(x.scope,'[data-pb-price]').forEach(el=>el.textContent='Variant not set');
      if(add&&!logoFlow){add.disabled=true;add.textContent='Unavailable'}
      return;
    }

    let total=cents(box);
    let invalid=box.available===false;

    if(usbAdded){
      const selected=usbSelection(x);
      if(!selected.variant){
        qa(x.scope,'[data-pb-price]').forEach(el=>el.textContent='Variant not set');
        if(add&&!logoFlow){add.disabled=true;add.textContent='Unavailable'}
        return;
      }
      invalid=invalid||selected.variant.available===false;
      total+=cents(selected.variant);
    }

    qa(x.scope,'[data-pb-price]').forEach(el=>
      el.textContent=invalid?'Unavailable':money(total)
    );

    if(add&&!logoFlow){
      add.disabled=invalid;
      add.textContent=invalid?'Unavailable':'Add to cart';
    }
  };

  // Deterministic fitting for the USB-box engraving preview. The previous DOM
  // overflow loop could collapse straight to the minimum size because the legacy
  // renderer and this repair layer both measure the same flex lines. Measure the
  // actual text once at the maximum size and solve the width/height constraints
  // directly; the result now starts large and only shrinks as content requires.
  const fitText=x=>{
    const box=q(x.scope,'[data-pb-preview-text].pb-photo-customizer__preview-text--usb');
    if(!box||box.hidden||box.style.display==='none'||!box.clientWidth||!box.clientHeight)return;

    const lines=qa(box,'.pb-photo-customizer__preview-line--usb');
    if(!lines.length)return;

    const maxSize=36;
    const minSize=10;
    const usableWidth=Math.max(1,box.clientWidth-8);
    const usableHeight=Math.max(1,box.clientHeight-6);
    const sample=getComputedStyle(lines[0]);
    const canvas=fitText.canvas||(fitText.canvas=document.createElement('canvas'));
    const ctx=canvas.getContext('2d');
    if(!ctx)return;

    ctx.font=`${sample.fontStyle||'normal'} ${sample.fontWeight||'400'} ${maxSize}px ${sample.fontFamily||'sans-serif'}`;
    const naturalWidth=Math.max(...lines.map(line=>ctx.measureText(line.textContent||'').width),1);
    const widthLimited=maxSize*Math.min(1,usableWidth/naturalWidth);
    const lineHeightFactor=1.08;
    const heightLimited=usableHeight/(Math.max(lines.length,1)*lineHeightFactor);
    const size=Math.max(minSize,Math.min(maxSize,Math.floor(widthLimited),Math.floor(heightLimited)));

    box.style.setProperty('--pb-usb-engraving-size',`${size}px`);
    box.dataset.pbAuditFitted=String(size);
  };

  const sync=x=>{
    syncLabels(x);
    syncPriceAndButton(x);
    fitText(x);
  };

  const schedule=x=>[0,35,90,180,360].forEach(ms=>setTimeout(()=>sync(x),ms));

  const addCanonical=async x=>{
    const boxVariants=parse(x.root,'[data-pb-variants-json]',[]);
    const color=d(x.scope,'[data-color]','color','Cream');
    const bs=boxState(x);
    const box=V.resolveVariant(boxVariants,{domain:'box',state:bs,requiredValues:[color]});
    const selected=usbSelection(x);
    const qty=Number(q(x.scope,'[data-pb-quantity]')?.value||1);

    if(!box?.available)throw Error('The selected box combination is unavailable.');
    if(!selected.product||!selected.variant?.available)throw Error('The selected USB combination is unavailable.');

    const boxProperties={};
    if(bs==='text'){
      const main=q(x.scope,'[data-pb-main-input]')?.value?.trim()||'';
      if(!main)throw Error('Please enter the main foil text.');
      boxProperties['Foil Color']=d(x.scope,'[data-foil]','foil','Matte Gold');
      boxProperties.Font='Goudy';
      boxProperties['Main Text']=main;
      const second=q(x.scope,'[data-pb-second-input]')?.value?.trim()||'';
      if(second)boxProperties['Optional Second Line']=second;
    }

    const us=usbState(x);
    const usbProperties={
      'Added with':cfg.productTitle||'Box',
      'USB Style':selected.product.title||'USB Drive',
      'Capacity':selected.capacity,
      'USB Engraving':us==='text'?'Yes':'No'
    };

    if(us==='text'){
      const text=q(x.scope,'[data-pb-usb-engraving-text]')?.value?.trim()||'';
      if(!text)throw Error('Please enter the USB engraving text.');
      usbProperties['USB Engraving Text']=text;
      usbProperties['USB Engraving Font']=q(x.scope,'[data-pb-usb-engraving-font]')?.value||'goudy';
      usbProperties['USB Engraving Color']=String(selected.product.type||'').toLowerCase().includes('wood')
        ?'Dark Brown':'White';
    }

    const add=q(x.scope,'[data-pb-add]');
    if(add){add.disabled=true;add.textContent='Adding...'}

    try{
      const response=await window.PBDesignSnapshot.add(x.root, `${window.Shopify?.routes?.root||'/'}cart/add.js`,{
        method:'POST',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({
          items:[
            {id:box.id,quantity:qty,properties:boxProperties},
            {id:selected.variant.id,quantity:qty,properties:usbProperties}
          ]
        })
      });
      if(!response.ok){
        let json={};
        try{json=await response.json()}catch{}
        throw Error(json.description||json.message||'Cart add failed');
      }
      window.location.href=`${window.Shopify?.routes?.root||'/'}cart`;
    }catch(error){
      if(add){add.disabled=false;add.textContent='Add to cart'}
      throw error;
    }
  };

  qa(document,ROOT_SELECTOR).forEach(root=>{
    const scope=q(root,MODAL_SELECTOR)||root;
    const x={root,scope};
    roots.push(x);
    sync(x);
  });

  document.addEventListener('click',event=>{
    const target=event.target instanceof Element?event.target:null;
    const x=ctxFor(target);
    if(!x)return;

    const add=target.closest('[data-pb-add]');
    const usbAdded=d(x.scope,'[data-usb-choice]','usbChoice','none')==='add';
    const noLogo=!a(x.scope,'[data-pb-logo="box"]')&&!a(x.scope,'[data-pb-logo="usb"]');

    if(add&&usbAdded&&noLogo){
      event.preventDefault();
      event.stopImmediatePropagation();
      addCanonical(x).catch(error=>{
        console.error('PB canonical USB-box cart add failed',error);
        const message=q(x.scope,'[data-pb-message]')||q(x.root,'[data-pb-message]');
        if(message){
          message.textContent=error.message||'Sorry, this customized item could not be added.';
          message.hidden=false;
        }
      });
      return;
    }
    schedule(x);
  },true);

  // After V2's visible capacity button has finished updating its compatibility
  // carrier, finish the same click task with the canonical calculation. This is
  // not a product exception: every USB style now gets the same authoritative
  // final price before the browser has a chance to paint an intermediate value.
  document.addEventListener('click',event=>{
    const target=event.target instanceof Element?event.target:null;
    if(!target?.closest('[data-pb-usb-capacity-v2]'))return;
    const x=ctxFor(target);
    if(x)sync(x);
  });

  ['input','change'].forEach(name=>document.addEventListener(name,event=>{
    const x=ctxFor(event.target);
    if(x)schedule(x);
  },true));

  document.fonts?.ready?.then(()=>roots.forEach(schedule));

  window.PBDesktopAuditCoreV1={
    version:VERSION,
    active:true,
    refresh:()=>roots.forEach(sync),
    debug:()=>roots.map(x=>{
      const u=usbSelection(x);
      return{
        usbChoice:d(x.scope,'[data-usb-choice]','usbChoice','none'),
        usbKey:u.key,
        capacity:u.capacity,
        state:usbState(x),
        variantId:u.variant?.id||null,
        variantPrice:u.variant?cents(u.variant):null,
        fittedSize:q(x.scope,'[data-pb-preview-text].pb-photo-customizer__preview-text--usb')?.dataset?.pbAuditFitted||null
      };
    })
  };
})();

